module.exports = __webpack_public_path__ + "img/userCenter.0b90fb11.png";